import { child, get, ref } from "firebase/database";
import { useEffect, useState } from "react";
import { MdOutlineNewLabel, MdSync } from "react-icons/md";

import { TiArrowBack } from "react-icons/ti";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { selectUserStatus, selectUserRole, graphStatus, fetchUserAccountInfo } from "../../common/authenticateDashboard/authSlice";
import { writeToFBDB } from "../../services/fbdb.data";
import { hasPermission } from "../../common/rbac/roles";
import { Button } from "../../components";
import Overlay from "../../components/NoDataFoundPage/NoDataFoundPage";
import CustomiseNudgeLoading from "../../components/Skeletons/CustomiseNudgeLoading";
import CustomiseNudgeLoading2 from "../../components/Skeletons/CustomiseNudgeLoading2";
import { defaultNudgeDb } from "../../firebase";
import { getNudgeData } from "../../helper";
import useAuth from "../../helper/CustomHooks/useAuth";
import {
  handleSaveAddPersona,
  handleSaveDeletePersona,
} from "../../helper/customizedNudge";
import { backfillNudgesToMongo } from "../../helper/customizedNudge/nudgeMongoApi";
import handleToast from "../../helper/Toast";
import CustomizeNudgeStats from "./CustomizeNudgeStats";
import { setGlobalNudgeData } from "./nudgeSlice";
import NudgeWrapper from "./NudgeWrapper";

const CustomizedNudge = () => {
  let user = useAuth();
  user = user?.split("@")[0];


  const [usersNudgeData, setUsersNudgeData] = useState({});
  const [userPersonaTypes, setUserPersonaTypes] = useState([]);
  const [allPersonaTypes, setAllPersonaTypes] = useState([]);
  const [availablePersonaTypes, setAvailablePersonaTypes] = useState([]);
  const [optimizerStatus, setOptimizerStatus] = useState(false);
  const [loading, setLoading] = useState(true);
  const [isLoading, setIsLoading] = useState({
    loading: true,
    message: "Loading...",
    error: false,
  });

  const userStatus = useSelector(selectUserStatus)
  const navigate = useNavigate()

  const userType = sessionStorage.getItem("userType");
  const isAdmin = userType === "admin";
  const [initializing, setInitializing] = useState(false);
  const [websiteURL, setWebsiteURL] = useState("");

  const handleInitializeNudge = async (e) => {
    e.preventDefault();
    let formattedURL = websiteURL.trim();
    if (!formattedURL) {
      handleToast("error", "Please enter a valid website URL");
      return;
    }
    if (!/^https?:\/\//i.test(formattedURL)) {
      formattedURL = "https://" + formattedURL;
    }

    setInitializing(true);
    try {
      // 1. Write graph-status metadata
      await writeToFBDB(`${user}/graph-status`, {
        campaign_opt_paid: "paid",
        funnel_optimizer: true,
        paid_status: "paid",
        persona_paid: "paid",
        persona_status: true
      });

      // 2. Write graph-account-info metadata
      await writeToFBDB(`${user}/graph-account-info`, {
        website: formattedURL
      });

      handleToast("success", "Nudge setup initialized successfully!");

      // Refresh redux state
      dispatch(graphStatus(user));
      dispatch(fetchUserAccountInfo(user));

      // Force optimizerStatus to true
      setOptimizerStatus(true);
    } catch (error) {
      console.error("Initialization failed:", error);
      handleToast("error", "Failed to initialize nudge setup.");
    } finally {
      setInitializing(false);
    }
  };

  useEffect(() => {
    if (userStatus?.funnel_optimizer) setOptimizerStatus(true);
    // console.log("userStatus : ", userStatus);
    setLoading(false);
  }, [userStatus])

  const dispatch = useDispatch();

  useEffect(() => {
    if (!user) return;
    try {

      const fetchGlobalNudgeData = async () => {
        try {
          const globalNudgeRef = child(ref(defaultNudgeDb), "dashboard-prod/customise_nudge");
          const snapshot = await get(globalNudgeRef);
          if (snapshot.exists()) {
            dispatch(setGlobalNudgeData(snapshot.val()));
            // console.log("Global Data", snapshot.val());
            console.log("Global Data fetched successfully");

          } else {
            console.error("No global nudge data found");
          }
        } catch (error) {
          console.error("Error fetching global nudge data:", error);
        }
      };
      fetchGlobalNudgeData();
      // get all nudge data from database
      getNudgeData(
        user,
        setUsersNudgeData,
        setUserPersonaTypes,
        setAllPersonaTypes,
        setAvailablePersonaTypes
      )
        .then(() => {
          setIsLoading({ loading: false, message: "Loading...", error: false });
        })
        .catch((error) => {
          setIsLoading({ loading: false, message: error, error: true });
        })
        .finally(() => {
          setIsLoading((prev) => ({ ...prev, loading: false }));
        });
    } catch (error) {
      console.error("Error fetching global nudge data:", error);
    }
  }, [user]);


  if (loading === true) return <CustomiseNudgeLoading2 />

  if (!optimizerStatus && !isAdmin) {
    return <Overlay />;
  }


  return (
    <>
      {optimizerStatus ? (
        <div className="CustomisableNudge bg-color bg-text w-full min-h-full flex flex-col" >
          <div className="flex items-center">
            <button
              className="bg-gray-500 text-white px-4 py-2 rounded-lg border 
    border-gray-500 hover:bg-gray-600 transition-all duration-300 
    ease-in-out font-semibold text-lg mt-4 ms-4 flex justify-center items-center gap-2"
              onClick={() => navigate("/bandit-test#design-type")}
            >
              <TiArrowBack className="text-xl" />
              Back
            </button>

          </div>

          <CustomizedNudgeHeader
            user={user}
            availablePersonaTypes={availablePersonaTypes}
            userPersonaTypes={userPersonaTypes}
            usersNudgeData={usersNudgeData}
          />
          <CustomizeNudgeStats
            usersNudgeData={usersNudgeData}
            userPersonaTypes={userPersonaTypes}
            user={user}
          />
          {isLoading.loading ? (
            <CustomiseNudgeLoading />
          ) : (
            <NudgeWrapper
              userPersonaTypes={userPersonaTypes}
              usersNudgeData={usersNudgeData}
              isLoading={isLoading}
              user={user}
            />
          )}

          {isLoading.error && (
            <p className="text-center text-red-500 font-bold">
              {isLoading.message}
            </p>
          )}
          <ToastContainer />
        </div>
      ) : isAdmin ? (
        <div className="CustomisableNudge bg-color bg-text w-full min-h-full flex items-center justify-center p-4 sm:p-6 md:p-8">
          <div className="w-full max-w-md md:max-w-lg bg-white border border-neutral-200 rounded-2xl p-6 sm:p-8 shadow-2xl text-neutral-800 transition-all duration-300">
            <div className="flex justify-center mb-6">
              <div className="flex items-center justify-center w-16 h-16 rounded-full bg-blue-50 text-blue-600 border border-blue-100 shadow-inner">
                <svg className="w-8 h-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                </svg>
              </div>
            </div>

            <h2 className="text-2xl font-bold text-center mb-2 tracking-tight text-neutral-900">Initialize Nudge Setup</h2>
            <p className="text-neutral-600 text-center mb-6 text-sm leading-relaxed">
              Setup is not yet initialized for client <span className="font-semibold text-neutral-900">{user}</span>. Please provide the website URL to initialize the database metadata.
            </p>

            <form onSubmit={handleInitializeNudge} className="space-y-6">
              <div>
                <label htmlFor="website-url" className="block text-sm font-medium text-neutral-700 mb-2">
                  Website URL
                </label>
                <input
                  type="text"
                  id="website-url"
                  placeholder="https://example.com"
                  value={websiteURL}
                  onChange={(e) => setWebsiteURL(e.target.value)}
                  className="w-full px-4 py-3 bg-neutral-50 border border-neutral-300 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-neutral-900 placeholder-neutral-400 transition duration-150 outline-none"
                  required
                />
              </div>

              <button
                type="submit"
                disabled={initializing}
                className="w-full py-3.5 bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-500 hover:to-indigo-500 disabled:opacity-50 text-white font-semibold rounded-xl shadow-lg hover:shadow-xl active:scale-[0.98] transition-all duration-200"
              >
                {initializing ? "Initializing Setup..." : "Initialize Setup"}
              </button>
            </form>
          </div>
          <ToastContainer />
        </div>
      ) : (
        <CustomiseNudgeLoading2 />
      )}
    </>
  );
};

const CustomizedNudgeHeader = ({
  user,
  availablePersonaTypes,
  userPersonaTypes,
  usersNudgeData,
}) => {
  const userRole = useSelector(selectUserRole);
  const canCreate = hasPermission(userRole, 'CREATE_NUDGES');

  const [isAddPersona, setIsAddPersona] = useState(false);
  const [isSyncing, setIsSyncing] = useState(false);

  // One-time backfill: push the currently-loaded nudges into MongoDB.
  // Firebase is untouched; this only mirrors existing data into the DB API.
  const handleSyncToDb = async () => {
    if (isSyncing) return;
    setIsSyncing(true);
    try {
      const summary = await backfillNudgesToMongo(
        user,
        usersNudgeData,
        userPersonaTypes
      );
      if (summary.failed > 0) {
        handleToast(
          "error",
          `Synced ${summary.success}/${summary.total} nudges (${summary.failed} failed)`
        );
      } else {
        handleToast("success", `Synced ${summary.success} nudge(s) to DB!`);
      }
    } catch (error) {
      console.error("Backfill error:", error);
      handleToast("error", "Failed to sync nudges to DB!");
    } finally {
      setIsSyncing(false);
    }
  };

  const handleAddPersona = () => {
    setIsAddPersona(true);
  };

  const handleCloseAddPersona = () => {
    setIsAddPersona(false);
  };

  return (
    <div className="customisable__nudge__header flex flex-col sm:flex-row justify-between items-center mx-4 sm:mx-14 py-4 ">
      <p className="header__text font-bold text-lg sm:text-2xl md:text-3xl">
        Customisable Nudges
      </p>
      <div className="header__buttons flex gap-3 items-center mt-2 sm:mt-0">
        {canCreate && (
          <Button
            Icon={MdOutlineNewLabel}
            active={false}
            onClick={handleAddPersona}
            title="ADD"
          />
        )}
        <Button
          Icon={MdSync}
          active={isSyncing}
          onClick={handleSyncToDb}
          title={isSyncing ? "SYNCING..." : "SYNC DB"}
        />
      </div>
      {isAddPersona && (
        <AddPersona
          user={user}
          availablePersonaTypes={availablePersonaTypes}
          handleCloseAddPersona={handleCloseAddPersona}
          userPersonaTypes={userPersonaTypes}
        />
      )}
    </div>
  );
};

const AddPersona = ({
  user,
  availablePersonaTypes,
  handleCloseAddPersona,
  userPersonaTypes,
}) => {
  const [selectedPersona, setSelectedPersona] = useState(
    availablePersonaTypes[0]
  );

  const handleCancel = () => {
    handleCloseAddPersona();
  };

  // save the selected persona to the database and update the userPersonaTypes and added the default property of the persona to the userNudgeData
  const handleSave = () => {
    handleSaveAddPersona(user, userPersonaTypes, selectedPersona);
    handleCloseAddPersona();
  };

  const handleChange = (e) => {
    const value = e.target.value;
    availablePersonaTypes.map(
      (persona, index) =>
        persona.optionValue === value && setSelectedPersona(persona)
    );
  };

  return (
    <div className="fixed z-10 inset-0 overflow-hidden">
      <div className="flex items-center justify-center min-h-screen text-center ">
        <div
          className="fixed inset-0 transition-opacity backdrop-blur-sm"
          aria-hidden="true"
        >
          <div className="absolute inset-0 bg-gray-500 opacity-75"></div>
        </div>
        <div className="modal__container relative bg-gray-600 p-4 rounded ">
          <p className="text-center text-xl font-bold mb-4">
            Select New Persona
          </p>
          {selectedPersona && (
            <p className="text-center text-xl font-bold mb-4">
              You have selected {selectedPersona.optionName}
            </p>
          )}
          <select
            name="addPersona"
            id="addPersona"
            className="mb-4 text-black"
            onChange={handleChange}
          >
            {availablePersonaTypes.map((persona, index) => {
              const { optionName, optionValue } = persona;
              return (
                <option key={index} value={optionValue}>
                  {optionName}
                </option>
              );
            })}
          </select>
          <div className="persona__buttons flex items-center justify-evenly">
            <Button title="CLOSE" onClick={handleCancel} />
            <Button title="SAVE" onClick={handleSave} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomizedNudge;
